 import React from 'react';
 import './Input.css';

 type InputProps = React.ComponentPropsWithoutRef<'input'> & {
   label: string;
 };

 export const Input = ({ label, id, ...props }: InputProps) => {
   return (
     <div className="input-group">
       <label htmlFor={id}>{label}</label>
       <input className="input-field" id={id} {...props} />
     </div>
   );
 };